module.exports = __webpack_public_path__ + "media/src/img/vimeo_logo_blue-8ec819fcb361186c501ee54c972d23ecff0d3fab33f0fed9d054bd7e54d5cbfc.png";